var _path, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmployees = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeWidth: 1.583,
    d: "M14.463 16.395c-.27-.842-.867-1.586-1.696-2.116-.83-.53-1.846-.818-2.892-.818s-2.062.287-2.892.818-1.426 1.274-1.696 2.116"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.875,
    cy: 7.914,
    r: 2.375,
    stroke: "#7E869E",
    strokeLinecap: "round",
    strokeWidth: 1.583
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.25,
    height: 14.25,
    x: 2.749,
    y: 2.378,
    stroke: "#7E869E",
    strokeWidth: 1.583,
    rx: 2.375
  })));
};
export default SvgEmployees;